import { useTheme } from "../../contexts/ThemeContext";
import styles from "./ThemeToggle.module.scss";

const ThemeToggle = () => {
  const { theme, themePreference, setThemePreference } = useTheme();

  return (
    <div className={styles.themeToggle}>
      {/*
       // @ts-expect-error TS2551 non-existing className */}
      <div className={styles.themeToggle__header}>
        {/*
         // @ts-expect-error TS2551 non-existing className */}
        <h3 className={styles.themeToggle__title}>Theme</h3>
        {/*
         // @ts-expect-error TS2551 non-existing className */}
        <p className={styles.themeToggle__description}>
          Choose between light and dark theme for your dashboard
        </p>
      </div>
      {/*
       // @ts-expect-error TS2551 non-existing className */}
      <div className={styles.themeToggle__options}>
        <button
          type="button"
          // @ts-expect-error TS2551 non-existing className
          className={`${styles.themeToggle__option} ${
            themePreference === "system"
              ? // @ts-expect-error TS2551 non-existing className
                styles.themeToggle__option_active
              : ""
          }`}
          onClick={() => setThemePreference("system")}
        >
          {/*
           // @ts-expect-error TS2551 non-existing className */}
          <div className={styles.themeToggle__optionIcon}>
            <svg width="20" height="20" viewBox="0 0 20 20" fill="none">
              <path
                d="M6 2a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2V4a2 2 0 0 0-2-2H6Z"
                stroke="currentColor"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
              <path
                d="M6 15h8v1a1 1 0 0 1-1 1H7a1 1 0 0 1-1-1v-1Z"
                fill="currentColor"
              />
            </svg>
          </div>
          {/*
           // @ts-expect-error TS2551 non-existing className */}
          <div className={styles.themeToggle__optionContent}>
            {/*
             // @ts-expect-error TS2551 non-existing className */}
            <span className={styles.themeToggle__optionTitle}>System</span>
            {/*
             // @ts-expect-error TS2551 non-existing className */}
            <span className={styles.themeToggle__optionDescription}>
              Follow your device preference{" "}
              {themePreference === "system" && `(${theme})`}
            </span>
          </div>
        </button>

        <button
          type="button"
          // @ts-expect-error TS2551 non-existing className
          className={`${styles.themeToggle__option} ${
            // @ts-expect-error TS2551 non-existing className
            themePreference === "light" ? styles.themeToggle__option_active : ""
          }`}
          onClick={() => setThemePreference("light")}
        >
          {/*
           // @ts-expect-error TS2551 non-existing className */}
          <div className={styles.themeToggle__optionIcon}>
            <svg width="20" height="20" viewBox="0 0 20 20" fill="none">
              <path
                d="M10 15a5 5 0 1 0 0-10 5 5 0 0 0 0 10Z"
                fill="currentColor"
              />
              <path
                d="M10 1v2M10 17v2M18.66 4.66l-1.41 1.41M4.75 15.25l-1.41 1.41M19 10h-2M3 10H1M18.66 15.34l-1.41-1.41M4.75 4.75 3.34 3.34"
                stroke="currentColor"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>
          </div>
          {/*
           // @ts-expect-error TS2551 non-existing className */}
          <div className={styles.themeToggle__optionContent}>
            {/*
             // @ts-expect-error TS2551 non-existing className */}
            <span className={styles.themeToggle__optionTitle}>Light</span>
            {/*
             // @ts-expect-error TS2551 non-existing className */}
            <span className={styles.themeToggle__optionDescription}>
              Clean and bright interface
            </span>
          </div>
        </button>

        <button
          type="button"
          // @ts-expect-error TS2551 non-existing className
          className={`${styles.themeToggle__option} ${
            // @ts-expect-error TS2551 non-existing className
            themePreference === "dark" ? styles.themeToggle__option_active : ""
          }`}
          onClick={() => setThemePreference("dark")}
        >
          {/*
           // @ts-expect-error TS2551 non-existing className */}
          <div className={styles.themeToggle__optionIcon}>
            <svg width="20" height="20" viewBox="0 0 20 20" fill="none">
              <path
                d="M17.293 13.293A8 8 0 0 1 6.707 2.707a8.001 8.001 0 1 0 10.586 10.586Z"
                fill="currentColor"
              />
            </svg>
          </div>
          {/*
           // @ts-expect-error TS2551 non-existing className */}
          <div className={styles.themeToggle__optionContent}>
            {/*
             // @ts-expect-error TS2551 non-existing className */}
            <span className={styles.themeToggle__optionTitle}>Dark</span>
            {/*
             // @ts-expect-error TS2551 non-existing className */}
            <span className={styles.themeToggle__optionDescription}>
              Easy on the eyes in low light
            </span>
          </div>
        </button>
      </div>
    </div>
  );
};

export default ThemeToggle;
